<div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">{{'Circuito' | translate}} - {{Circuito.Titulo}}</h4>
    <button type="button" class="close" [disabled]="carregando" aria-label="Close" (click)="fecharModal()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
  
    <div class="overlay" *ngIf="carregando">
      <img src="assets/img/loading3.gif" class="imagem">
    </div>
  
    <ul ngbNav #nav="ngbNav" class="nav-pills mb-3 mt-md-2 mt-2 mx-2 mx-md-2">
        <li [ngbNavItem]="'daybyday'">
          <a ngbNavLink>Day By Day</a>
          <ng-template ngbNavContent>
            <div class="p-3">
              <div *ngIf="Detalhes?.DaybyDay?.length > 0; else semDaybyDay">
                <div class="accordion" id="dayByDayAccordion">
                  <div class="accordion-item" *ngFor="let dayByDay of Detalhes.DaybyDay; let i = index">
                    <h2 class="accordion-header" [id]="'heading' + i">
                      <button class="accordion-button" [class.collapsed]="i !== 0" type="button"
                        data-bs-toggle="collapse"
                        [attr.data-bs-target]="'#collapse' + i"
                        [attr.aria-expanded]="i === 0"
                        [attr.aria-controls]="'collapse' + i">
                      <i class="fa fa-bars me-2"></i>
                        {{ dayByDay.Titulo }} - {{ dayByDay.Dia }}
                      </button>
                    </h2>
                    <div [id]="'collapse' + i" class="accordion-collapse collapse" [class.show]="i === 0"
                      [attr.aria-labelledby]="'heading' + i" data-bs-parent="#dayByDayAccordion">
                      <div class="accordion-body text-center">
                        <p [innerHTML]="dayByDay.Descricao"></p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <ng-template #semDaybyDay>
                <p class="text-muted text-center">Nenhum item do Day By Day disponível.</p>
              </ng-template>
            </div>
          </ng-template>
        </li>
        
        <li *ngIf="Detalhes?.Observacoes?.length > 0" [ngbNavItem]="'observacoes'">
          <a ngbNavLink>Observações</a>
          <ng-template ngbNavContent>
            <div class="p-3">
              <div *ngFor="let observacao of Detalhes.Observacoes">
                <p [innerHTML]="observacao"></p>
              </div>
            </div>
          </ng-template>
        </li>
    
        <li *ngIf="Circuito.Fornecedor !== 'SRL'" [ngbNavItem]="'servicos-inclusos'">
          <a ngbNavLink>Serviços Inclusos</a>
          <ng-template ngbNavContent>
            <div class="p-3">
              <div *ngFor="let servico of Detalhes.ServicosInclusos">
                <p [innerHTML]="servico"></p>
              </div>
            </div>
          </ng-template>
        </li>
    
        <li *ngIf="Circuito.Fornecedor !== 'SRL'" [ngbNavItem]="'hoteis-previstos'">
          <a ngbNavLink>Hotéis Previstos</a>
          <ng-template ngbNavContent>
            <div class="p-3">
              <div *ngFor="let hotelPrevisto of Detalhes?.HoteisPrevistos; let i = index"
                class="row mb-3">
                <div class="col-md-6 d-flex" style="font-size: 18px !important;">
                  <p class="text-muted"><strong class="text-muted">{{"Hotel" | translate}}: </strong> {{hotelPrevisto?.Nome}}</p>
                </div>
    
                <div *ngIf="Circuito.Fornecedor == 'ST' else europamundoEstrelas" class="col-md-2 text-center">
                  <strong>{{"Categoria" | translate}}: </strong>{{hotelPrevisto?.Categoria}}
                </div>
    
                <ng-template #europamundoEstrelas class="col-md-2 text-center">
                  <app-estrela [estrela]="hotelPrevisto.Categoria"></app-estrela>
                </ng-template>
    
                <div class="col-md-2 text-right"><strong>{{"Cidade" | translate}}: </strong>{{hotelPrevisto?.Cidade}}</div>
                <div class="col-md-2 text-right"><strong>{{"País" | translate}}: </strong>{{hotelPrevisto?.Pais}}</div>
    
              </div>
            </div>
          </ng-template>
        </li>
    
        <li *ngIf="Circuito.Fornecedor != 'ST'" [ngbNavItem]="'imagens'">
          <a ngbNavLink>Imagens</a>
          <ng-template ngbNavContent>
            <ngb-carousel *ngIf="Imagens">
              <ng-template ngbSlide *ngFor="let img of Imagens; let i = index">
                <img [src]="Img" alt="Imagem {{i+1}}" style="height: 82vh; width: 100% !important; object-fit: cover; border-radius: 10px;
                  border: 2px solid gray;" />
              </ng-template>
            </ngb-carousel>
          </ng-template>
        </li>
      </ul>
      <div [ngbNavOutlet]="nav"></div>
  </div>
  
  <div class="modal-footer">
    <div *ngIf="mensagemErro?.length > 0" class="alert alert-danger alert-dismissible fade show col col-md-12"
      role="alert">
      <strong>{{ mensagemErro}}</strong><br>
      <button type="button" class="close" data-dismiss="alert" aria-label="Close" (click)="mensagemErro = ''">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
  </div>
  
